// @flow
import { teamPreferences } from 'common/middleware/api';
import { ApiError } from 'common/modules/api';
import { injectError } from './error';

export default class TeamPreferencesActions {
    static FETCH_TEAM_PREFERENCES_START = 'FETCH_TEAM_PREFERENCES_START';
    static FETCH_TEAM_PREFERENCES_COMPLETE = 'FETCH_TEAM_PREFERENCES_COMPLETE';
    static INJECT_TEAM_PREFERENCES = 'INJECT_TEAM_PREFERENCES';

    static fetchTeamPreferences(teamId: string, clientId: string) {
        const params = {
            clientId,
            teamId
        };

        return dispatch => {
            dispatch(TeamPreferencesActions.startFetchingTeamPreferences());
            teamPreferences
                .fetch(params)
                .then(teamPreferences => {
                    dispatch(
                        TeamPreferencesActions.injectTeamPreferences(
                            teamPreferences,
                            params
                        )
                    );
                })
                .catch(error => {
                    dispatch(
                        TeamPreferencesActions.completeFetchingTeamPreferences()
                    );
                    if (error instanceof ApiError) {
                        dispatch(injectError(error));
                    } else {
                        throw error;
                    }
                });
        };
    }

    static startFetchingTeamPreferences(): Object {
        return {
            type: TeamPreferencesActions.FETCH_TEAM_PREFERENCES_START
        };
    }

    static completeFetchingTeamPreferences(): Object {
        return {
            type: TeamPreferencesActions.FETCH_TEAM_PREFERENCES_COMPLETE
        };
    }

    static injectTeamPreferences(teamPreferences, params): Object {
        return {
            type: TeamPreferencesActions.INJECT_TEAM_PREFERENCES,
            response: teamPreferences,
            params
        };
    }
}
